import { Button } from "@app/components/ui/button";
import { Input } from "@app/components/ui/input";
import { Label } from "@app/components/ui/label";
import ValueDisplayScore from "./ValueDisplayScore";
import { MageXPatient } from "@prisma/client";
import { Trans } from "@lingui/macro";
import dayjs from "dayjs";
interface Score {
  date: string;
  score: number;
}

/**
 * La saisie date + total d'un score lu dans un courrier.
 *
 * CONTRÔLÉ, et sans pied de modale à lui : la série vit dans le brouillon de
 * ``ValueEditModal``, qui porte l'unique bouton d'enregistrement. Tant que cet éditeur
 * gardait sa copie et son propre couple Annuler/Enregistrer, la modale avait deux pieds
 * selon le type du champ, et deux règles pour décider quand enregistrer.
 */
interface ScoreInputProps {
  value?: Array<Score>;
  property: keyof MageXPatient;
  onChange: (scores: Array<Score>) => void;
}

export default function ValueScoreInput({
  value,
  property,
  onChange,
}: ScoreInputProps) {
  // ``Array.isArray`` et non ``?? []`` : la colonne porte parfois la série sous forme de
  // chaîne JSON, et ``.map`` sur une chaîne ferait tomber la modale entière.
  const scores: Array<Score> = Array.isArray(value) ? value : [];

  const addScore = () => {
    onChange([...scores, { date: "", score: undefined as unknown as number }]);
  };

  const removeScore = (index: number) => {
    onChange(scores.filter((_, i) => i !== index));
  };

  const updateScore = (
    index: number,
    field: keyof Score,
    value: string | number,
  ) => {
    const newScores = [...scores];
    newScores[index] = {
      ...newScores[index],
      [field]: field === "score" ? Number(value) : value,
    };
    onChange(newScores);
  };

  return (
    <>
      <div className="flex flex-row gap-4 items-start">
        <div className="flex-1 basis-96">
          {scores?.length > 0 && (
            <ValueDisplayScore
              property={property}
              aggregatedValue={scores}
              isAlwaysHovered={true}
            />
          )}
        </div>
        <div className="space-y-4 overflow-y-auto max-h-96">
          {scores.map((score, index) => (
            <div key={index} className="flex gap-4 items-end">
              <div className="flex-1">
                <Label>Date</Label>
                <Input
                  type="date"
                  value={dayjs(score.date).format("YYYY-MM-DD")}
                  onChange={(e) => updateScore(index, "date", e.target.value)}
                />
              </div>
              <div className="flex-1">
                <Label>Score</Label>
                <Input
                  type="number"
                  value={score.score}
                  onChange={(e) => updateScore(index, "score", e.target.value)}
                  step="0.01"
                />
              </div>
              <Button
                variant="outline"
                size="sm"
                type="button"
                onClick={() => removeScore(index)}
                className="mb-0.5"
              >
                <Trans>Supprimer</Trans>
              </Button>
            </div>
          ))}
          <div className="flex justify-between">
            <Button type="button" variant="outline" onClick={addScore}>
              <Trans>Ajouter un score</Trans>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
